const KEY = "sz_broker_appts";
const newId = () => crypto.randomUUID?.() ?? Math.random().toString(36).slice(2) + Date.now().toString(36);

export const loadAppts = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
export const saveAppts = (arr) => { try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch {} };

export const addAppt  = (appt) => { const a = [{ id: newId(), created_at: new Date().toISOString(), ...appt }, ...loadAppts()]; saveAppts(a); return a; };
export const delAppt  = (id)   => { const a = loadAppts().filter((x) => x.id !== id); saveAppts(a); return a; };

export const APPT_TYPES = [
  { value: "call",        label: "Call" },
  { value: "showing",     label: "Showing" },
  { value: "open_house",  label: "Open house" },
  { value: "photographer",label: "Photographer" },
  { value: "staging",     label: "Staging" },
  { value: "closing",     label: "Closing" },
  { value: "other",       label: "Other" },
];

// Returns ISO date string "YYYY-MM-DD" for a Date object
export const toDateStr = (d) => d.toISOString().slice(0, 10);

// Returns the 7 days (Mon–Sun) for the week containing `ref`
export const weekDays = (ref = new Date()) => {
  const mon = new Date(ref);
  mon.setDate(ref.getDate() - ((ref.getDay() + 6) % 7));
  return Array.from({ length: 7 }, (_, i) => { const d = new Date(mon); d.setDate(mon.getDate() + i); return d; });
};
